import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
const EventSource = EventSourcePolyfill;

let token;
export const setTokenEventSource = (_token) =>{
    token = _token;
}
export const getEventSourceInstance = (url) =>{
    const _header = {
        'Authorization': 'Bearer ' + token
      }
    return new EventSourcePolyfill(url,{ https: {rejectUnauthorized: false},headers: _header});
}

